const checkIsActiveVisitPage = pathname =>
  pathname === '/waitingRoom' || /^\/visit\/.*$/.test(pathname);

export default { checkIsActiveVisitPage };
